import {
  FETCH_BOOK_PERFORMANCE_PUBLISHERS,
  FETCH_BOOK_PERFORMANCE_PUBLISHERS_SUCCESS,
  FETCH_BOOK_PERFORMANCE_PUBLISHERS_FAILURE,
  FETCH_BOOK_PERFORMANCE,
  FETCH_BOOK_PERFORMANCE_SUCCESS,
  FETCH_BOOK_PERFORMANCE_FAILURE,
  FETCH_BOOK_PERFORMANCE_TREND,
  FETCH_BOOK_PERFORMANCE_TREND_SUCCESS,
  FETCH_BOOK_PERFORMANCE_TREND_FAILURE,
  FETCH_BOOK_PERFORMANCE_DETAIL,
  FETCH_BOOK_PERFORMANCE_DETAIL_SUCCESS,
  FETCH_BOOK_PERFORMANCE_DETAIL_FAILURE,
  CLEAR_BOOK_PERFORMANCE_DETAIL,
  EXPORT_BOOK_PERFORMANCE_CSV,
  EXPORT_BOOK_PERFORMANCE_CSV_SUCCESS,
  EXPORT_BOOK_PERFORMANCE_CSV_FAILURE,
  FETCH_BOOK_PERFORMANCE_AUTHORS,
  FETCH_BOOK_PERFORMANCE_AUTHORS_SUCCESS,
  FETCH_BOOK_PERFORMANCE_AUTHORS_FAILURE,
  FETCH_AUTHOR_BOOK_PERFORMANCE,
  FETCH_AUTHOR_BOOK_PERFORMANCE_SUCCESS,
  FETCH_AUTHOR_BOOK_PERFORMANCE_FAILURE,
  FETCH_AUTHOR_BOOK_PERFORMANCE_TREND,
  FETCH_AUTHOR_BOOK_PERFORMANCE_TREND_SUCCESS,
  FETCH_AUTHOR_BOOK_PERFORMANCE_TREND_FAILURE,
} from "../ActionTypes";

const dataset = (data) => ({ data, loading: false, error: null, loaded: false });
const INITIAL_STATE = {
  publishers: dataset([]),
  monthly: dataset(null),
  trend: dataset(null),
  detail: dataset(null),
  export: dataset(null),
  authors: dataset([]),
  authorMonthly: dataset(null),
  authorTrend: dataset(null),
};

const actions = {
  [FETCH_BOOK_PERFORMANCE_PUBLISHERS]: ["publishers", "request"],
  [FETCH_BOOK_PERFORMANCE_PUBLISHERS_SUCCESS]: ["publishers", "success"],
  [FETCH_BOOK_PERFORMANCE_PUBLISHERS_FAILURE]: ["publishers", "failure"],
  [FETCH_BOOK_PERFORMANCE]: ["monthly", "request"],
  [FETCH_BOOK_PERFORMANCE_SUCCESS]: ["monthly", "success"],
  [FETCH_BOOK_PERFORMANCE_FAILURE]: ["monthly", "failure"],
  [FETCH_BOOK_PERFORMANCE_TREND]: ["trend", "request"],
  [FETCH_BOOK_PERFORMANCE_TREND_SUCCESS]: ["trend", "success"],
  [FETCH_BOOK_PERFORMANCE_TREND_FAILURE]: ["trend", "failure"],
  [FETCH_BOOK_PERFORMANCE_DETAIL]: ["detail", "request"],
  [FETCH_BOOK_PERFORMANCE_DETAIL_SUCCESS]: ["detail", "success"],
  [FETCH_BOOK_PERFORMANCE_DETAIL_FAILURE]: ["detail", "failure"],
  [EXPORT_BOOK_PERFORMANCE_CSV]: ["export", "request"],
  [EXPORT_BOOK_PERFORMANCE_CSV_SUCCESS]: ["export", "success"],
  [EXPORT_BOOK_PERFORMANCE_CSV_FAILURE]: ["export", "failure"],
  [FETCH_BOOK_PERFORMANCE_AUTHORS]: ["authors", "request"],
  [FETCH_BOOK_PERFORMANCE_AUTHORS_SUCCESS]: ["authors", "success"],
  [FETCH_BOOK_PERFORMANCE_AUTHORS_FAILURE]: ["authors", "failure"],
  [FETCH_AUTHOR_BOOK_PERFORMANCE]: ["authorMonthly", "request"],
  [FETCH_AUTHOR_BOOK_PERFORMANCE_SUCCESS]: ["authorMonthly", "success"],
  [FETCH_AUTHOR_BOOK_PERFORMANCE_FAILURE]: ["authorMonthly", "failure"],
  [FETCH_AUTHOR_BOOK_PERFORMANCE_TREND]: ["authorTrend", "request"],
  [FETCH_AUTHOR_BOOK_PERFORMANCE_TREND_SUCCESS]: ["authorTrend", "success"],
  [FETCH_AUTHOR_BOOK_PERFORMANCE_TREND_FAILURE]: ["authorTrend", "failure"],
};

const bookPerformanceReducer = (state = INITIAL_STATE, action) => {
  if (action.type === CLEAR_BOOK_PERFORMANCE_DETAIL) {
    return { ...state, detail: dataset(null) };
  }
  const config = actions[action.type];
  if (!config) return state;
  const [key, lifecycle] = config;
  if (lifecycle === "request")
    return { ...state, [key]: { ...state[key], loading: true, error: null } };
  if (lifecycle === "success")
    return { ...state, [key]: { data: action.payload, loading: false, error: null, loaded: true } };
  return { ...state, [key]: { ...state[key], loading: false, error: action.payload } };
};

export default bookPerformanceReducer;
